import React from 'react'
import { useRef } from 'react';
import Slider from 'react-slick';

const SliderConstruction = () => {
    const settings = {
        dots: true,
        arrows: false,
        infinite: true,
        centerMode: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        variableWidth: true,
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 580,
                settings: {
                    adaptiveHeight: false,
                    variableWidth: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    };

    const slider1 = useRef(null);

    const previous = () => {
        slider1.current.slickNext();
    };

    const next = () => {
        slider1.current.slickPrev();
    };
    return (
        <Slider ref={slider1} {...settings} className="wrapper__slider-construction">
            <div className="items">
                <img src="./../images/kapı (5).png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/kapı (10).png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/sdsadas.png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/sürgülü kapı (24).jpg" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/telçit (9).png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/ds (1).png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/ds (2).png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/ds (3).png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/ds (4).png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/ds (5).png" className='images__construction' alt="" />
            </div>
            <div className="items">
                <img src="./../images/zemin.webp" className='images__construction' alt="" />
            </div>
            
        </Slider>
    )
}

export default SliderConstruction